namespace GeniuzPOS.InventoryReport {
    export interface IcReport05AllRow {
        Id?: string;
        SkuCode?: string;
        SkuDesc?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SupplId?: string;
        SupplName?: string;
        StockFg?: number;
        ConsignFg?: number;
        GroupType?: string;
        EomIn?: number;
        IcReceive?: number;
        IcReturnOut?: number;
        IcSold?: number;
        IcReturnIn?: number;
        IcAdjIn?: number;
        IcAdjOut?: number;
        SumOut?: number;
        DateMonth?: string;
        DateYear?: string;
    }

    export namespace IcReport05AllRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'InventoryReport.IcReport05All';
        export const deletePermission = '2Inventory:รายงาน:มูลค่า:View';
        export const insertPermission = '2Inventory:รายงาน:มูลค่า:View';
        export const readPermission = '2Inventory:รายงาน:มูลค่า:View';
        export const updatePermission = '2Inventory:รายงาน:มูลค่า:View';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SupplId = "SupplId",
            SupplName = "SupplName",
            StockFg = "StockFg",
            ConsignFg = "ConsignFg",
            GroupType = "GroupType",
            EomIn = "EomIn",
            IcReceive = "IcReceive",
            IcReturnOut = "IcReturnOut",
            IcSold = "IcSold",
            IcReturnIn = "IcReturnIn",
            IcAdjIn = "IcAdjIn",
            IcAdjOut = "IcAdjOut",
            SumOut = "SumOut",
            DateMonth = "DateMonth",
            DateYear = "DateYear"
        }
    }
}
